// Prezzo unico della licenza, in un solo posto: la landing, il paywall a pieno schermo e
// l'UpgradeDialog devono mostrare la stessa cifra, e il JSON-LD generato da scripts/seo-build.js
// deve coincidere con quella mostrata a video (un Offer che contraddice la pagina è uno
// structured-data mismatch per Google).
//
// L'importo effettivamente addebitato vive in Stripe (price con lookup_key `visioscreen_full`,
// creato da backend/setup_stripe.py): queste costanti sono solo la vetrina. Se cambi il prezzo,
// aggiorna anche AMOUNT in setup_stripe.py e rilancia lo script sull'account Stripe.
export const PRICE_DECIMAL = "34.99"; // formato schema.org / Stripe
export const PRICE_LABEL = "34,99 €"; // formato italiano, quello mostrato

// Prezzo di listino barrato accanto a quello corrente. Metti a null per togliere lo sconto:
// i componenti smettono di mostrare sia il barrato sia il badge di percentuale.
export const LIST_PRICE_LABEL = "49,99 €";

// -30% arrotondato all'intero: 1 - 34,99/49,99 = 0,3001…
export const DISCOUNT_LABEL = LIST_PRICE_LABEL
  ? `-${Math.round((1 - parseFloat(PRICE_DECIMAL) / parseFloat(LIST_PRICE_LABEL.replace(",", "."))) * 100)}%`
  : null;
